import { fetchRequest, errorUtil } from '@app/util'

const query = `mutation CountryDeleteMutation(
  $organization: ID!
  $country: ID!
) {
  countryDelete (
    organization: $organization
    country: $country
  )}`

async function requestCountryDelete (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errorUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errorUtil.apiError('something went wrong', errors)
  }
  return data
}

export default requestCountryDelete
